import {
    $, $$, $e, $each,
    init,
    onClick,
    onClickHash, onKeyTrigger,
    onReady,
    vAnimRun,
} from "../../core/cfjs";
import {initForm} from "./form/app.js";
import {validateContactForm} from "./form/validators.js";
import {lockPageScroll, unlockPageScroll} from './scroll.js';

init({loadedAnimAfter: null});


onReady(() => {
    function initDropdown(buttonSelector) {
        const btn = $(buttonSelector);
        if (!btn) return;
        const dropdown = $(".dropdown-menu", btn.closest(".dropdown"))
        const arrow = $(".arrow-down", btn);

        btn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();

            const isOpen = btn.classList.toggle("is-open");
            dropdown.style.display = isOpen ? "block" : "none";
            arrow.style.transform = isOpen ? "rotate(180deg)" : "rotate(0deg)";

            $each(".dropdown .is-open", otherBtn => {
                if (otherBtn !== btn) {
                    otherBtn.classList.remove("is-open");
                    const otherDropdown = $(".dropdown-menu", otherBtn.closest(".dropdown"));
                    const otherArrow = otherBtn.querySelector(".arrow-down");
                    otherDropdown.style.display = "none";
                    otherArrow.style.transform = "rotate(0deg)";
                }
            })
        });
    }

    initDropdown(".header-service-btn");
    initDropdown(".header-area-btn");

    $e(d, 'click', ({target}) => {
        $each(".dropdown .is-open", (btn) => {
            if (!btn.contains(target)) {
                btn.classList.remove("is-open");
                const menu = $(".dropdown-menu", btn.closest(".dropdown"));
                const arrow = $(".arrow-down", btn)
                menu.style.display = "none";
                arrow.style.transform = "rotate(0deg)";
            }
        })
    })
});

onReady(() => {
    vAnimRun(".footer", () => vAnimRun("#hero"));
});

onClick("header-burger", () => {
    bc.toggle("header-menu-active");
    const isOpen = bc.contains("header-menu-active");
    $each("[data-action='header-burger']", (btn) => {
        if (btn.classList.contains("header-burger")) {
            btn.setAttribute("aria-expanded", isOpen);
            btn.setAttribute("aria-label", isOpen ? "Close main menu" : "Open main menu");
        }
    });
});

onClickHash(() => {
    bc.remove("header-menu-active");
});

// ===== SWIPERS =====
onReady(() => {
    new Swiper(".myReviews", {
        spaceBetween: 20,
        grabCursor: true,
        loop: false,
        pagination: {
            el: ".reviews .swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            0: {slidesPerView: "auto"},
            768: {slidesPerView: "auto"},
            1200: {slidesPerView: 3},
        },
    });

    let servicesSwiper = null;
    const servicesSelector = ".myServices";
    const servicesPaginationSelector = ".services .swiper-pagination";
    const mq = window.matchMedia("(max-width: 1023px)");

    function enableServicesSwiper() {
        if (servicesSwiper || !document.querySelector(servicesSelector)) return;
        servicesSwiper = new Swiper(servicesSelector, {
            spaceBetween: 20,
            loop: false,
            grabCursor: true,
            pagination: {
                el: servicesPaginationSelector,
                clickable: true,
            },
            slidesPerView: "auto",
        });
        $(servicesPaginationSelector).classList.remove("is-hidden")
    }

    function disableServicesSwiper() {
        if (!servicesSwiper) return;
        servicesSwiper.destroy(true, true);
        servicesSwiper = null;
        document
            .querySelector(servicesPaginationSelector)
            ?.classList.add("is-hidden");
    }

    function applyServicesSwiper() {
        if (mq.matches) enableServicesSwiper();
        else disableServicesSwiper();
    }

    applyServicesSwiper();

    if (mq.addEventListener) {
        mq.addEventListener("change", applyServicesSwiper);
    } else {
        window.addEventListener("resize", applyServicesSwiper);
    }
});

// ===== MULTI-MODAL LOGIC  =====
onReady(() => {
    const bookingModal = $("#booking-modal");
    const callModal = $("#call-modal");

    function openModal(modal) {
        if (!modal) return;
        modal.classList.add("open");
        bc.add("modal-open");
        lockPageScroll();
    }

    function closeModal(modal) {
        if (!modal) return;
        modal.classList.remove("success", "error", "open");
        if (!$(".modal.open")) {
            bc.remove("modal-open");
            unlockPageScroll();
        }
    }

    const calcRoot = $("#multi-booking-form");
    let calculatorInitialized = false;

    function ensureCalculatorInit() {
        if (!calculatorInitialized && calcRoot) {
            initForm(calcRoot);
            calculatorInitialized = true;
        }
    }

    function presetCalculatorService(serviceName) {
        if (!serviceName || !calcRoot) return;
        const input = $(`.option-card input[name='serviceCard'][value='${serviceName}']`, calcRoot);
        if (!input) return;
        input.closest(".option-card")?.dispatchEvent(new Event("click", {bubbles: true}));
    }

    function openBookingCalculator(serviceName = null) {
        if (!bookingModal || !calcRoot) return;
        ensureCalculatorInit();
        presetCalculatorService(serviceName);
        openModal(bookingModal);
    }

    function handleCalcHash() {
        const {hash} = location;
        if (hash === "#calc") {
            openBookingCalculator();
            return;
        }
        const match = hash.match(/^#calc-([a-z]+)$/);
        if (match) openBookingCalculator(match[1]);
    }

    handleCalcHash();
    window.addEventListener("hashchange", handleCalcHash);

    $each(".book-now", btn => {
        $e(btn, "click", e => {
            e.preventDefault();
            openBookingCalculator(btn.getAttribute("data-service"));
        });
    });

    $each('.call-now', btn => {
        $e(btn, 'click', e => {
            e.preventDefault();
            openModal(callModal);
        })
    })

    $each('.modal-close, .fx-close', el => {
        $e(el, 'click', e => {
            const modal = e.target.closest(".modal");
            closeModal(modal);
        })
    })

    onKeyTrigger(d, 'Escape', () => {
        const open = $(".modal.open");
        if (open) closeModal(open);
    })

});
// ===== BOOKING FORM INIT INSIDE MODAL =====

// ===== COMPARISON SLIDER =====
const sliders = $$(".comparison-slider");
const countEl = $(".comparison-count");
const nextBtn = $(".comparison-next");
const prevBtn = $(".comparison-prev");

let index = 0;

function showSlide(i) {
    sliders.forEach((s) => s.classList.remove("active"));
    sliders[i].classList.add("active");
    if (countEl) countEl.textContent = `${i + 1}/${sliders.length}`;
}

if (nextBtn && prevBtn && sliders.length) {
    $e(nextBtn, 'click', () => {
        index = (index + 1) % sliders.length;
        showSlide(index);
    })

    $e(prevBtn, 'click', () => {
        index = (index - 1 + sliders.length) % sliders.length;
        showSlide(index);
    })

}

sliders.forEach((slider) => {
    const after = $(".comparison-after", slider);
    const handle = $(".comparison-handle", slider);
    if (!after || !handle) return;

    let isDown = false;

    function move(x) {
        const rect = slider.getBoundingClientRect();
        let pos = ((x - rect.left) / rect.width) * 100;
        pos = Math.max(0, Math.min(100, pos));
        after.style.clipPath = `inset(0 ${100 - pos}% 0 0)`;
        handle.style.left = `${pos}%`;
    }

    $e(slider, 'mousedown', e => {
        isDown = true;
        move(e.clientX);
    })

    $e(slider, 'mousemove', e => {
        isDown && move(e.clientX);
    })

    $e(window, 'mouseup', () => (isDown = false))
    $e(slider, 'touchstart', (e) => move(e.touches[0].clientX))
    $e(slider, 'touchmove', (e) => move(e.touches[0].clientX))

});


const sendForm = (name, form) => {
    const els = form.elements

    const res = {formName: form.getAttribute("name")};
    form.classList.add("loading");

    const errMsg = $('.form-error-msg', form);
    const msgOK = $('.form-success-msg', form);

    errMsg.textContent = '';

    if (msgOK) {
        msgOK.textContent = '';
    }
    for (let i = 0; i < els.length; i++) {
        const item = els[i]
        res[item.name] = item.value
    }


    const onError = () => {
        errMsg.textContent = 'An error occurred. Your request was not submitted. Please try again later.';
        form.classList.remove("loading");
    }
    fetch('https://api.ozarks-cleaning.com/contacts', {
        method: "POST",
        body: JSON.stringify(res),
        headers: {
            'Content-Type': 'application/json'
        },
    }).then(e => e.json()).then((res) => {
        if (res.status) {
            launchConfettiVanilla('#call-modal');
            const modal = form.closest('.modal');
            if (modal)
                modal.classList.add('success');


            if (msgOK) {
                msgOK.textContent = 'Your request has been submitted successfully. We will contact you shortly.';
            }
            form.reset();
            form.classList.remove("loading");
        } else {
            onError()
        }
    }).catch(onError)
}


onReady(() => {
    setTimeout(() => {
        const $hero = $('.hero-video');
        if ($hero) {
            $hero.play();
        }

    }, 1000)

    $each(".contact-form", (form) => {
        form.addEventListener("submit", (e) => {
            e.preventDefault();
            const errors = validateContactForm(form);

            $each(".error-msg", (el) => {
                el.textContent = "";
                el.classList.add("hidden");
            }, $(".contact-form"))


            if (Object.keys(errors).length) {
                for (const [key, msg] of Object.entries(errors)) {
                    const errEl = form.querySelector(`[data-error-for="${key}"]`);
                    if (errEl) {
                        errEl.textContent = msg;
                        errEl.classList.remove("hidden");
                    }
                }
                return;
            }
            const formName = form.getAttribute('name');
            if (formName === 'contactForm' || formName === 'calc') {
                return sendForm('contacts', form)
            }
        });

        $each("input, textarea", (input) => {
            input.addEventListener("input", () => {
                const errEl = $(`[data-error-for="${input.id}"]`, form);
                if (errEl && !errEl.classList.contains("hidden")) {
                    errEl.textContent = "";
                    errEl.classList.add("hidden");
                }
            });
            if (input.type === "checkbox") {
                $e(input, 'change', () => {
                    const errEl = form.querySelector(`[data-error-for="${input.id}"]`);
                    if (errEl && !errEl.classList.contains("hidden")) {
                        errEl.textContent = "";
                        errEl.classList.add("hidden");
                    }
                });
            }
        })
    })
})


window.launchConfettiVanilla = (rootSelector = '#booking-modal') => {
    const root = $(rootSelector)
    if (!root) return

    const count = 60
    const colors = ['#F46234', '#FFD166', '#06D6A0', '#118AB2', '#EF476F']

    for (let i = 0; i < count; i++) {
        const conf = document.createElement('div')
        conf.className = 'confetti-piece'
        conf.style.left = Math.random() * 100 + '%'
        conf.style.backgroundColor =
            colors[Math.floor(Math.random() * colors.length)]
        conf.style.width = 6 + Math.random() * 4 + 'px'
        conf.style.height = 10 + Math.random() * 6 + 'px'
        conf.style.opacity = Math.random().toFixed(2)
        conf.style.transform = `rotate(${Math.random() * 360}deg)`

        root.appendChild(conf)

        const fall = conf.animate(
            [
                {
                    transform: `translateY(0) rotate(${Math.random() * 360}deg)`,
                    opacity: 1,
                },
                {
                    transform: `translateY(${window.innerHeight}px) rotate(${
                        720 + Math.random() * 360
                    }deg)`,
                    opacity: 0,
                },
            ],
            {
                duration: 2500 + Math.random() * 1000,
                easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
                delay: Math.random() * 300,
            },
        )

        fall.onfinish = () => conf.remove()
    }
}

$each('.spoiler', (el) => {
    $e(el, 'click', () => {
        el.classList.add('is-open');
    })
})